import { apiClient } from '@/lib/apiClient';

export interface AiLogEntry {
  logId: string;
  requestId: string;
  userId: string;
  endpointKey: string;
  promptKey: string;
  promptVersion: string;
  model: string;
  tokensIn: number;
  tokensOut: number;
  latencyMs: number;
  costUsdEstimate: number;
  cacheHit: boolean;
  validationOutcome: 'valid' | 'repaired' | 'fallback' | 'error';
  requestedAt: string;
  respondedAt: string;
}

export interface AiStats {
  totalRequests: number;
  totalCost: number;
  totalTokensIn: number;
  totalTokensOut: number;
  cacheHitRate: number;
  averageLatencyMs: number;
  validationOutcomes: { valid: number; repaired: number; fallback: number; error: number };
  byEndpoint: Record<string, { count: number; cost: number; cacheHits: number }>;
}

export interface AiPrompt {
  key: string;
  version: string;
  systemPrompt: string;
  userPromptTemplate: string;
  outputSchemaKey: string;
  temperature: number;
  maxTokens: number;
  isActive: boolean;
  updatedAt: string;
  updatedBy: string;
  createdAt: string;
}

export interface AiPromptHistoryEntry {
  key: string;
  version: string;
  systemPrompt: string;
  userPromptTemplate: string;
  createdAt: string;
  createdBy: string;
  changeNote: string;
}

export interface UpdatePromptBody {
  systemPrompt?: string;
  userPromptTemplate?: string;
  temperature?: number;
  maxTokens?: number;
  isActive?: boolean;
  changeNote?: string;
}

export interface ListLogsParams {
  limit?: number;
  cursor?: string;
  endpointKey?: string;
  userId?: string;
  startDate?: string;
  endDate?: string;
}

export const aiApi = {
  listLogs: (params: ListLogsParams = {}) =>
    apiClient.get<{ logs: AiLogEntry[]; nextCursor?: string | null }>('/ai/logs', {
      ...params,
    }),
  stats: (params: { startDate?: string; endDate?: string } = {}) =>
    apiClient.get<AiStats>('/ai/stats', { ...params }),
  listPrompts: () =>
    apiClient.get<{ prompts: AiPrompt[] }>('/ai/prompts'),
  getPrompt: (key: string) =>
    apiClient.get<{ prompt: AiPrompt; history: AiPromptHistoryEntry[] }>(
      `/ai/prompts/${encodeURIComponent(key)}`,
    ),
  updatePrompt: (key: string, body: UpdatePromptBody) =>
    apiClient.put<{ prompt: AiPrompt }>(
      `/ai/prompts/${encodeURIComponent(key)}`,
      body,
    ),
};
